<template>
  <v-container fluid>
    <v-row>
      <v-col xs12>
        <v-card>
          <v-toolbar dark>
            <v-toolbar-title>Legal Notice</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-layout column justify-center align-center>
              <span style="font-weight: bold">Contact Information</span>
              <span style="text-align: center">TAKT.ing GmbH</span>
              <span style="text-align: center">Alte Bergstraße 436</span>
              <span style="text-align: center">86899 Landsberg am Lech</span>
              <span><br /></span>
              <span style="text-align: center">E-Mail: info@takting.com</span>
              <span><br /></span>
              <span style="text-align: center">HRB 34165</span>
              <span style="text-align: center">Geschäftsführung:</span>
              <span style="text-align: center">Dipl.-Ing. Marco Binninger</span>
              <span style="text-align: center">Janosch Dlouhy M.Eng</span>
              <span><br /></span>
              <span style="font-weight: bold">Disclaimer:</span>
              <span style="text-align: center">All rights reserved, unless expressly stated otherwise. All contents merely provide a non-binding overview of the company, the product, the vision and our goals. For the correctness, completeness or
                topicality of the data no guarantee is taken over.</span>
              <span><br /></span>
              <span style="font-weight: bold">Legal Information:</span>
              <span style="text-align: center">The contents of this website are regularly adapted. We reserve the right to make changes or additions to the information provided without prior notice. We are not liable for direct or indirect damages
                arising from or in connection with information provided on this website. The content of this website is protected by copyright.</span>
              <span><br /></span>
              <span style="font-weight: bold">Data Protection:</span>
              <span style="text-align: center">We refer to our privacy policy. If you have any questions, please contact us at the above contact details.</span>
              <span><br /></span>
              <span style="font-weight: bold">Unsubscribe:</span>
              <span style="text-align: center">You can always unsubscribe from our mailing list by sending an email to the above address, including unsubscribe in the topic.</span>
              <span><br /></span>
              <span style="font-weight: bold">3rd party software</span>
              <span style="text-align: center"><a target="_blank" href="https://github.com/axios/axios/blob/master/LICENSE">axios</a></span>
              <span style="text-align: center"><a target="_blank" href="https://github.com/bootstrap-vue/bootstrap-vue/blob/dev/LICENSE">bootstrap-vue</a></span>
              <span style="text-align: center"><a target="_blank" href="https://github.com/zloirock/core-js/blob/master/LICENSE">core-js</a></span>
              <span style="text-align: center"><a target="_blank" href="https://github.com/Keyamoon/svgxuse/blob/master/license">svgxuse</a></span>
              <span style="text-align: center"><a target="_blank" href="https://github.com/vuejs/vue/blob/dev/LICENSE">vue</a></span>
              <span style="text-align: center"><a target="_blank" href="https://github.com/imcvampire/vue-axios/blob/master/LICENSE">vue-axios</a></span>
              <span style="text-align: center"><a target="_blank" href="https://github.com/cmp-cc/vue-cookies/blob/master/LICENSE">vue-cookies</a></span>
              <span style="text-align: center"><a target="_blank" href="https://github.com/P3trur0/vue-country-flag/blob/master/LICENSE">vue-country-flag</a></span>
              <span style="text-align: center"><a target="_blank" href="https://github.com/Binaryify/vue-custom-scrollbar/blob/master/LICENSE">vue-custom-scrollbar</a></span>
              <span style="text-align: center"><a target="_blank" href="https://github.com/ittus/vue-long-click/blob/master/LICENSE">vue-long-click</a></span>
              <span style="text-align: center"><a target="_blank" href="https://github.com/vuejs/vue-router/blob/dev/LICENSE">vue-router</a></span>
              <span style="text-align: center"><a target="_blank" href="https://github.com/achwilko/vue-svg-custom-icon/blob/master/LICENSE">vue-svg-custom-icon</a></span>
              <span style="text-align: center"><a target="_blank" href="https://github.com/SortableJS/Vue.Draggable/blob/master/LICENSE">vuedraggable</a></span>
              <span style="text-align: center"><a target="_blank" href="https://github.com/vuetifyjs/vuetify/blob/master/LICENSE.md">vuetify</a></span>
              <span style="text-align: center"><a target="_blank" href="https://github.com/slimphp/Slim/blob/4.x/LICENSE.md">SLIM</a></span>
              <span style="text-align: center"><a target="_blank" href="https://github.com/doctrine/orm/blob/master/LICENSE">Doctrine ORM</a></span>
              <span style="text-align: center"><a target="_blank" href="https://github.com/doctrine/dbal">Doctrine DBAL</a></span>
              <span style="text-align: center"><a target="_blank" href="https://github.com/doctrine/common">Doctrine common</a></span>
              <span style="text-align: center"><a target="_blank" href="https://github.com/firebase/php-jwt/blob/master/LICENSE">firebase php-jwt</a></span>
              <span style="text-align: center"><a target="_blank" href="https://github.com/aws/aws-sdk-php/blob/master/LICENSE.md">aws-sdk-php</a></span>
              <span style="text-align: center"><a target="_blank" href="https://github.com/leezng/vue-json-pretty/blob/dev/LICENSE">vue-json-pretty</a></span>
              <span style="text-align: center"><a target="_blank" href="https://github.com/Fuxy526/vue-snowf/blob/master/LICENSE">vue-snowf</a></span>

            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-btn :to="{name: redirect, params: params}" text>Back</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data: function () {
    return {
      redirect: 'Home'
    };
  },
  props: ['params'],
  created(){
    if (this.$route.query && this.$route.query.redirect) {
      this.redirect = this.$route.query.redirect;
    }
  }
}
</script>
